module.exports = "/src/views/player/help/images/gang2.jpg";